<script setup lang="tsx">
import { computed } from "vue";
import { __color, getCSSVar } from "@zyzgroup/core-web";

const props = withDefaults(
  defineProps<{
    colorStart?: string;
    colorEnd?: string;
  }>(),
  {
    colorStart: getCSSVar("--xg-red", "#fa503c"),
    colorEnd: getCSSVar("--xg-red-light", "#fa8c78")
  }
);

const opposite = computed(() =>
  __color.set(props.colorStart).opposite(true).toString()
);
</script>

<template>
  <!-- origin viewBox : x y width height : 0 0 24 24 , 目前 viewBox 是为了切除四周多余空白 -->
  <!-- 不设置 width height , 自适应父元素 -->
  <svg
    viewBox="4 4 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :style="{
      display: 'block',
      transformOrigin: 'center'
    }"
  >
    <defs>
      <!-- 对于同一个id，浏览器可能会渲染优化，导致后面更新的linearGradient不起作用 -->
      <linearGradient
        :id="`circle_bg_${colorStart}_${colorEnd}`"
        x1="12"
        y1="4"
        x2="12"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0"
          :stop-color="colorStart"
        />
        <stop
          offset="1"
          :stop-color="colorEnd"
        />
      </linearGradient>
      <!-- <pattern
        :id="`charge_line_${colorStart}`"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlink:href="#image0_10315_2409"
          transform="scale(0.01)"
        />
      </pattern>
      <image
        id="image0_10315_2409"
        width="100"
        height="100"
        preserveAspectRatio="none"
        xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAArJJREFUeF7tnVFSg1AMRe2PK3CJLsslugJ/dBgHpyJUuORCQo7fzeVxDslri+LtiZ9UBG6pVsNinhCS7CJACEKSEUi2HDoEIckIJFsOHVJVyOvHy+eRa397fm95saw+6aOF3MvvJKeEkEFOFyllhHSRslrIkfvHcKylEXn1TkkrZLwA5sRcWUp6IUvdclUpJYTMSUHI0ZvI5HjT0YWQk4V06ZIyIwshCTpiuoQOY4sOSXbhIQQhOgFGls7OUokQC1Y9FCE6O0slQixY9VCE6OwslQixYNVDEaKzs1QixIJVD0WIzs5SiRALVj0UITo7SyVCLFj1UITo7CyVCLFg1UMRorOzVCLEglUPRYjOzlKJEAtWPRQhOjtLJUIsWPVQhOjsLJUIsWDVQxGis7NUIsSCVQ9FiM7OUokQC1Y9FCE6O0slQixY9VCE6OwslQixYNVDEaKzs1QixIJVD0WIzs5SiRALVj30aCHT4+krX/80I/7GcIZypIgxfu2DDhByJ8QhAiHiXHHKGJZEh2wQ80jGWpAbDvfwpYyshYelHS1itNReyFx3nCVjkIKQyeNvz5TRXki27kBIsu5ACEL2vTmM/uokOm/f2X1Xt93UM8pAyN0lffa7q/afQ+iQgAEbCTEyK+DUfiJa7iFZZbTdQxAS1NNRIKNygk7rVwwja8O9CoeAaWY7IZm7o+UegpDAPo+AGZEReEp/ohhZyf49Xysh2buj3R6CkOBhuxfo3vrg05mNazOyMt6unTPSVkiWr9tLfzAcFq+MnSrdUW5TV4RUknEJIcNJLI2fajJKCpnrki3vfrLuHSVv4Y6LVn9TPbuMsh2ytUsqiCjdIfcj6r9uqSSjdIds2TcqvbbUB8NKYNW1IkQlZ6pDiAmsGosQlZypDiEmsGosQlRypjqEmMCqsV9WddB0Dtx5kgAAAABJRU5ErkJggg=="
      /> -->
    </defs>
    <!-- <rect
      width="50"
      height="50"
      :fill="`url(#charge_line_${colorStart})`"
    /> -->
    <circle
      cx="12"
      cy="12"
      r="8"
      :fill="`url(#circle_bg_${colorStart}_${colorEnd})`"
    />
    <!-- 竖线 -->
    <path
      d="M11.4666 8.80006C11.4666 8.50551 11.7053 8.26672 11.9999 8.26672C12.2944 8.26672 12.5332 8.50551 12.5332 8.80006V13.0667C12.5332 13.3613 12.2944 13.6001 11.9999 13.6001C11.7053 13.6001 11.4666 13.3613 11.4666 13.0667V8.80006Z"
      :fill="opposite"
    />
    <!-- 小圆点 -->
    <path
      d="M11.4666 15.2001C11.4666 14.9055 11.7053 14.6667 11.9999 14.6667C12.2944 14.6667 12.5332 14.9055 12.5332 15.2001C12.5332 15.4946 12.2944 15.7334 11.9999 15.7334C11.7053 15.7334 11.4666 15.4946 11.4666 15.2001Z"
      :fill="opposite"
    />
  </svg>
</template>
